var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductForm',{attrs:{"productDetail":_vm.productDetail,"update":false},on:{"saveDetail":_vm.saveProduct}})
}
var staticRenderFns = []

export { render, staticRenderFns }